<template>
	<section class="updates">
		<h3>latest updates</h3>
		<div class="container">
			<div v-for="update in state.updates" :key="update.id">
				<hr>
				<p>
					<time :datetime="update.created_date">{{ formattedDate(update.created_date) }}</time>
					| {{ update.message }}
				</p>
			</div>
			<hr>
		</div>
	</section>
</template>

<script>
import { onMounted, reactive } from 'vue';
import updateService from '../services/UpdatesDataService';

export default {
	name: 'Updates',
	setup() {
		const state = reactive({
			updates: []
		})

		const formattedDate = (date) => {
			return new Date(date).toDateString()
		}

		onMounted(() => {
			console.log('Calling updates api')
			updateService.getAll().then(res => {
				state.updates = res.data.Items
				console.log(res)
			})
			console.log('Api done')
		})

		return {
			state,
			formattedDate
		}
	}
}
</script>

<style scoped>
hr {
	width: 90%;
	opacity: .5;
}

.container {
	max-height: 250pt;
	overflow: auto;
}

.updates {
	/* border: 1pt solid white; */
	height: 300pt;
	border-radius: 10pt;
	padding: 10pt;
}

.container::-webkit-scrollbar {
    width: 10pt;
}
 
.container::-webkit-scrollbar-track {
	border-radius: 20pt;
}
 
.container::-webkit-scrollbar-thumb {
	border-radius: 20pt;
	background-color: rgba(0, 0, 0, 0.5);
}
</style>